import React from "react";
import { Navigator, Button, Icon } from "react-onsenui";
import WelcomeTooltip from "./components/popup/Welcome";  // Import tooltip component
import AboutUsContent from "./pages/AboutUsPage";  // Import About Us page
import AnalyzePage from "./pages/AnalyzePage";

import HelpPage from "./pages/HelpPage";
import SubstancesIndexPage from "./pages/SubstancesIndexPage";
import SubstancePage from "./pages/SubstancePage";
import HamburgerMenu from "./components/HamburgerMenu";
import { getSubstance, getSubstanceByToken } from "./services/megamix";

const style = {
  container: {
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
    display: "flex",
    flex: 1,
    width: "100%",
    height: "100%",
    background: "#EDECF2"
  },
  app: {
    width: "900px",
    height: "100%",
    position: "relative"
  },
  crash: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  p: {
    marginBottom: "30px"
  }
};

window.addEventListener('load', () => {
  const splash = document.getElementById('splash-screen');
  splash.style.display = 'none';
  document.body.classList.remove('loading');
});

const reloadApp = () => {
  window.location = '/results';
};

export default class WebApp extends React.Component {
  state = { didCrash: false, error: '', info: '', showAboutUs: false };

  handleLearnMore = () => {
    this.setState({ showAboutUs: true }, () => {
      window.scrollTo(0, 0);  // Scroll to the top
    });
  };

  renderPage(route, navigator) {
    const props = {
      ...(route.props || {}),
      navigator: navigator
    };
    return React.createElement(route.component, props);
  }

  componentDidCatch(error, info) {
    this.setState({ didCrash: true, error, info });
  }

  renderCrash() {
    return (
      <div style={style.container}>
        <div style={style.crash}>
          {/* <Icon id="icon" size={80} icon="fa-skull" /> */}
          <h3>Error. Please report to test@protestkit.eu.</h3>
          <p style={style.p}>{`Error: ${this.state.error}`}</p>
          <Button onClick={() => reloadApp()}>Reload the App</Button>
        </div>
      </div>
    );
  }

  render() {
    if (this.state.didCrash === true) {
      return this.renderCrash();
    }

    return (
      <div>
        {/* Tooltip with Learn More handling */}
        <WelcomeTooltip onLearnMore={this.handleLearnMore} />

        {/* Conditionally render the About Us content */}
        {this.state.showAboutUs ? (
          <AboutUsContent />
        ) : (
          <AnalyzePage NoOnsen={true} />
        )}
      </div>
    );
  }
}


